import { useCallback } from 'react'

import { useAudioRef } from '../providers/AudioRefProvider'

// Returns a stable getter for the shared dock's current playhead (seconds), read on demand (e.g. when
// a comment composer focuses) so callers don't re-render on every playback frame.
export const useGetPlaybackTime = (): (() => number) => {
    const audioRef = useAudioRef()

    return useCallback(() => audioRef.current?.currentTime ?? 0, [audioRef])
}
